import { RiskMatrixCellWire } from 'app/area/risk-matrix-administration/types';
import { RiskMatrixCell, RiskMatrixCellProperty } from 'app/area/risk-matrix-administration/types-store';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

export const mapCellsToStore = (cellsWire: RiskMatrixCellWire[]): RiskMatrixCell[] => cellsWire?.map(cell => ({
  riskArea: cell.riskArea,
  riskWeight: cell.riskWeight,
  ...isDefinedIncludingZero(cell.recurrence?.v) && ({ [RiskMatrixCellProperty.recurrence]: cell.recurrence.v }),
  ...isDefinedIncludingZero(cell.severity?.v) && ({ [RiskMatrixCellProperty.severity]: cell.severity.v }),
  ...isDefinedIncludingZero(cell.likelihood?.v) && ({ [RiskMatrixCellProperty.likelihood]: cell.likelihood.v }),
  ...isDefinedIncludingZero(cell.code?.v) && ({ id: cell.code.v })
}));
